import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { CustomWorksheetTemplateOverview, CustomWorksheetTemplateStatus, CWTTypeEnum } from '../types/custom-worksheet-v2';
import { EntityTypeEnum } from '../types/entity';

type GetCustomWorksheetTemplatesParams = {
    search?: string;
    status?: CustomWorksheetTemplateStatus;
    entityType?: EntityTypeEnum[];
    allowAsSchedule?: boolean;
};

type GetCustomWorksheetTemplatesResponse = {
    templates: CustomWorksheetTemplateOverview[];
    totalItems: number;
};

async function getCustomWorksheetTemplates(params: GetCustomWorksheetTemplatesParams): Promise<GetCustomWorksheetTemplatesResponse | null> {
    const { data } = await api.get(`/templates/custom-worksheets`, { params });
    return data;
}

export function useCustomWorksheetTemplates(
    params: GetCustomWorksheetTemplatesParams
): UseQueryResult<GetCustomWorksheetTemplatesResponse, AxiosError> {
    return useQuery(['custom-worksheet-templates', ...Object.values(params)], () => getCustomWorksheetTemplates(params), {
        keepPreviousData: true,
    });
}
